export default "__VITE_ASSET__Cw5nKy9I__"